import { render, staticRenderFns } from "./order_info.vue?vue&type=template&id=14f969da&scoped=true&"
import script from "./order_info.vue?vue&type=script&lang=js&"
export * from "./order_info.vue?vue&type=script&lang=js&"
import style0 from "./order_info.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./order_info.vue?vue&type=style&index=1&id=14f969da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f969da",
  null
  
)

export default component.exports